import styled from '@emotion/styled';

const Wrapper = styled('div')(
    ({ theme }) => `
        max-width: calc(${theme.pageWidth}px + (${theme.spacing['16px']} * 2));
        margin: 0 auto;
        padding: 0 ${theme.spacing['16px']};

        ${theme.mq.large} {
            padding: 0 ${theme.spacing['32px']};
            max-width: calc(${theme.pageWidth}px + (${theme.spacing['32px']} * 2));
        }
    `
);

export default Wrapper;
